import { MenuItem, Stack, TableCell, TableHead, TableRow } from "@mui/material";
import { ReactComponent as MemberIcon } from "assets/images/icons/member.svg";
import { ReactComponent as EditIcon } from "assets/images/square-buttons/edit-line.svg";
import { ReactComponent as ViewIcon } from "assets/images/square-buttons/more.svg";
import { ReactComponent as TrashIcon } from "assets/images/square-buttons/squared-trash.svg";
import ScreenLoader from "components/ScreenLoader";
import Tooltip from "components/Tooltip";
import { STAFF_STATUS_OPTIONS } from "constants/index";
import SortButton from "containers/Members/SortButton";
import { stringToColor } from "helpers/utils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import StatusListDropdown from "../Dropdown";

export const TableHeader = ({ sortingCallback, pageParams }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="left"></TableCell>
        <TableCell align="left">
          <SortButton
            label={`Last Name`}
            value={`LAST_NAME`}
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="left">
          <SortButton
            label={`First Name`}
            value={`FIRST_NAME`}
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="left">
          <SortButton
            label={`Assigned Members`}
            value={`ASSIGNED_MEMBERS`}
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="left">Staff Type</TableCell>
        <TableCell align="left">
          <SortButton
            label={`Status`}
            value={`STATUS`}
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="right">Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export const TableItem = ({ data, onUpdateStatus, onEdit, onDelete = null }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(data?.status_string || "");

  const details = () => {
    navigate(`/staffs/${data?.id}`);
  };
  return (
    <TableRow role="checkbox">
      <TableCell align="left">
        <Stack direction={"row"} alignItems="center">
          <span
            style={{ backgroundColor: stringToColor(`${data.first_name} ${data.last_name}`) }}
            className={"rounded-circle member-icon"}
          >
            <MemberIcon width={24} height={24} stroke={"#fff"} />
          </span>
        </Stack>
      </TableCell>
      <TableCell align="left" className="bold black" width="15%">
        {data?.last_name}
      </TableCell>
      <TableCell align="left" className="bold black" width="15%">
        {data?.first_name}
      </TableCell>
      <TableCell align="left" className="bold" width="10%">
        {data?.assigned_members}
      </TableCell>
      <TableCell align="left" className="bold" width="10%">
        {data?.type_string}
      </TableCell>
      <TableCell align="left" className="bold" width="25%">
        {loading && <ScreenLoader isScreenLoader />}
        {!loading && (
          <StatusListDropdown
            name="status"
            label="Status"
            value={currentStatus}
            defaultValue={currentStatus}
            onChange={async (e) => {
              setLoading(true);
              let result = await onUpdateStatus(data.id, e.target.value);
              setLoading(false);
              if (result) {
                setCurrentStatus(e.target.value.toString());
              }
            }}
            fullWidth={true}
            className={`select ${currentStatus === "IN_ACTIVE" ? `bg-ash` : `bg-primary`}`}
          >
            {STAFF_STATUS_OPTIONS.filter((o) => !!o.value).map((o) => (
              <MenuItem
                disabled={data?.assigned_members && o.value === "IN_ACTIVE"}
                value={o.value}
              >
                {o.label}
              </MenuItem>
            ))}
          </StatusListDropdown>
        )}
      </TableCell>
      <TableCell align="right" width="15%">
        <div className={"buttons-bar"}>
          {onDelete && typeof onDelete === "function" && (
            <Tooltip content={"Delete"} direction="bottom">
              <button onClick={() => onDelete(data)}>
                <TrashIcon />
              </button>
            </Tooltip>
          )}
          <Tooltip content={"Edit"} direction="bottom">
            <button onClick={() => onEdit(data)}>
              <EditIcon />
            </button>
          </Tooltip>
          <Tooltip content={"View"} direction="bottom">
            <button onClick={details}>
              <ViewIcon />
            </button>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
};
